import type { TimesheetState } from '@timesheet/shared';
import { Badge } from '@/components/ui/Badge';

const stateConfig: Record<
  TimesheetState,
  { label: string; tone: 'neutral' | 'info' | 'warning' | 'success' | 'danger' }
> = {
  draft: { label: 'Draft', tone: 'neutral' },
  submitted: { label: 'Submitted', tone: 'info' },
  manager_approved: { label: 'Manager approved', tone: 'info' },
  partner_approved: { label: 'Partner approved', tone: 'success' },
  rejected: { label: 'Rejected', tone: 'danger' },
};

export function StateBadge({ state }: { state: TimesheetState }) {
  const cfg = stateConfig[state];
  return <Badge tone={cfg.tone}>{cfg.label}</Badge>;
}
